import { render, staticRenderFns } from "./IndexConfiguracionCamara.vue?vue&type=template&id=197ced80&scoped=true&"
import script from "./IndexConfiguracionCamara.vue?vue&type=script&lang=ts&"
export * from "./IndexConfiguracionCamara.vue?vue&type=script&lang=ts&"
import style0 from "./IndexConfiguracionCamara.vue?vue&type=style&index=0&id=197ced80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197ced80",
  null
  
)

export default component.exports